export const ERROR_ID = {
  NETWORK_ERROR: 'NETWORK_ERROR',
  PUZZLE_IS_FULL: 'PUZZLE_IS_FULL',
  ROOM_IS_FULL: 'ROOM_IS_FULL',
  PUZZLE_HAS_ALREADY_STARTED: 'PUZZLE_HAS_ALREADY_STARTED',
};

export const EXPECTED_BUSINESS_REJECTIONS = new Set([
  ERROR_ID.PUZZLE_IS_FULL,
  ERROR_ID.ROOM_IS_FULL,
  ERROR_ID.PUZZLE_HAS_ALREADY_STARTED,
]);
